import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=348ff71a&scoped=true&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ff71a",
  null
  
)

export default component.exports